module.exports = __webpack_public_path__ + "static/img/xm@2x.bcde50fd.png";